module.exports = __webpack_public_path__ + "1b2abaa708aafd22172f4a7ad850682a.svg";